<h1>Zugang zurücksetzen</h1>

<p>
  Sollten Sie Ihr Passwort vergessen haben, können Sie dies hier zurücksetzen.<br>
  Sofern ein Zugang zu der von Ihnen angegebenen E-Mail-Adresse besteht,
  wird Ihnen ein neues Passwort per E-Mail zugesendet.<br>
  Falls Ihr Zugang noch nicht aktiviert wurde, erhalten Sie stattdessen einen neuen Aktivierungslink.
</p>

<form [formGroup]="form" class="login-form" (ngSubmit)="onSubmit()">
  <div>
    <mat-form-field class="login-input">
      <input autocomplete="off" matInput placeholder="E-Mail-Adresse" [formControl]="emailControl"
             type="text">
      <mat-error *ngIf="emailControl.hasError('email') || emailControl.hasError('required')">
        Bitte geben Sie ein gültige E-Mail-Adresse ein
      </mat-error>
    </mat-form-field>
  </div>
  <div class="submit">
    <button mat-raised-button [disabled]="loading" class="login-button">
      <mat-spinner *ngIf="loading"></mat-spinner>
      <mat-icon [class.hidden]="loading">lock_reset</mat-icon>
      Zurücksetzen
    </button>
  </div>
</form>

<div class="errors">
  <div *ngIf="errFailure">
    <mat-icon>close</mat-icon>
    Es ist ein Fehler aufgetreten.
  </div>
</div>
